import {
  TAKER_UPDATE_DATA_REQUEST, TAKER_UPDATE_DATA_SUCCESS, TAKER_UPDATE_DATA_ERROR,
  // TAKER_RETRIEVE_REQUEST, TAKER_RETRIEVE_SUCCESS, TAKER_RETRIEVE_ERROR,
  TAKER_CREATE_REQUEST, TAKER_CREATE_SUCCESS, TAKER_CREATE_ERROR,
  GLOBAL_QUOTATION_RESET_STATE_TAKER, GLOBAL_QUOTATION_SET_TAKER_DATA,
  TAKER_CREATE_OR_UPDATE_REQUEST, TAKER_CREATE_OR_UPDATE_SUCCESS, TAKER_CREATE_OR_UPDATE_ERROR,
} from 'Redux/types/globalQuotationTypes';


export const initialClientData = {
  textSearch: '',
  created: null,
  client_id: null,
  client_softseguros_id: null,
  document_type: 'CC',
  document_number: null,
  first_name: null,
  last_name: null,
  birthday_date: null,
  gender: 'MASCULINO',
  email: null,
  phone_number: null,
  // campos pendientes por validar
  created: false, // identifica si fue un cliente creado u obtenido
};

const initianState = {
  ...initialClientData,

  requestState: {
    isFeching: false,
    message: '',
    statusCode: null,
  },

};

// Se unifica en una función la extracción de los valores del cliente creado o actualizado
const getJsonTakerFromResponse = (response) => ({
  client_id: response.data.id,
  client_softseguros_id: response.data.softseguros_id,
  document_type: response.data.document_type,
  document_number: response.data.document_number,
  first_name: response.data.first_name,
  last_name: response.data.last_name,
  birthday_date: response.data.birthday_date,
  gender: response.data.gender,
  email: response.data.email,
  created: response.data.created,
  phone_number: response.data.phone_number,
});

const takerReducer = (state = initianState, actions) => {
  switch (actions.type) {
    case TAKER_UPDATE_DATA_REQUEST:
      return ({
        ...state,
        requestState: {
          isFeching: true,
        },
      });
    case TAKER_UPDATE_DATA_SUCCESS:
      return ({
        ...state,
        ...getJsonTakerFromResponse(actions.response),
        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      });
    case TAKER_UPDATE_DATA_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      });
      // casos para obtener un cliente
      // case TAKER_RETRIEVE_REQUEST:
      //   return ({
      //     ...state,
      //     requestState: {
      //       isFeching: true,
      //     },
      //   });
      // case TAKER_RETRIEVE_SUCCESS:
      //   return ({
      //     ...state,
      //     id: actions.response.data.results[0].id,
      //     birthday_date: actions.response.data.results[0].birthday_date,
      //     created: actions.response.data.results[0].created,
      //     document_number: actions.response.data.results[0].document_number,
      //     email: actions.response.data.results[0].email,
      //     first_name: actions.response.data.results[0].first_name,
      //     gender: actions.response.data.results[0].gender,
      //     last_name: actions.response.data.results[0].last_name,
      //     requestState: {
      //       isFeching: false,
      //       message: '',
      //       statusCode: actions.response.status,
      //     },
      //   });
      // case TAKER_RETRIEVE_ERROR:
      //   return ({
      //     ...state,
      //     requestState: {
      //       isFeching: false,
      //       message: actions.response.data.message,
      //       statusCode: actions.response.status,
      //     },
      //   });

    // casos para crear un cliente
    case TAKER_CREATE_REQUEST:
      return ({
        ...state,
        requestState: {
          isFeching: true,
        },
      });
    case TAKER_CREATE_SUCCESS:
      return ({
        ...state,
        ...getJsonTakerFromResponse(actions.response),
        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      });

    case TAKER_CREATE_ERROR:
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      });

    case GLOBAL_QUOTATION_RESET_STATE_TAKER:
      return ({
        ...state,
        ...initianState,
        ...actions.defaults,
      });

    case GLOBAL_QUOTATION_SET_TAKER_DATA:
      return ({
        ...state,
        ...actions.newData,
      });

    // ----------------------- ----------------------- ----------------------- ----------------------- ----------------------- 
    // CREAR o actualizar un cliente
    case TAKER_CREATE_OR_UPDATE_REQUEST: {
      return ({
        ...state,
        requestState: {
          isFeching: true,
        },
      });
    }
    case TAKER_CREATE_OR_UPDATE_SUCCESS: {
      return ({
        ...state,
        ...getJsonTakerFromResponse(actions.response),
        requestState: {
          isFeching: false,
          message: '',
          statusCode: actions.response.status,
        },
      });
    }
    case TAKER_CREATE_OR_UPDATE_ERROR: {
      return ({
        ...state,
        requestState: {
          isFeching: false,
          message: actions.response.data.message,
          statusCode: actions.response.status,
        },
      });
    }

    default:
      return state;
  }
};

export default takerReducer;
